import { fetchApi } from '@/config/axiosSetting.ts';
import {
  CreateZipType,
  CreateZipQueryResponseType,
} from '@/modules/FileDetail/queries/documentation/createZip/createZipFile/createZipFileQuery.type';

export const createZipFileQueryFunction = ({
  id,
}: CreateZipType): Promise<CreateZipQueryResponseType> =>
  fetchApi.get(`documents/${id}/file_document_zip/create/`);
